import {
  withAnalyticsEvents,
  WithAnalyticsEventsProps
} from '@atlaskit/analytics-next';
import DropdownMenu from '@atlaskit/dropdown-menu';
import React, { Component } from 'react';
import { UserProfileView } from './user-profile-view';

import { ProductDropdownItemProps } from './components/product-dropdown-item';
import { Trigger } from './components/trigger';
import { messages } from './messages';
import { trackingData } from './tracking';

export { ProductDropdownItemProps };

export type UserProfileDropdownProps = {
  readonly userName: string;
  readonly userEmail: string;
  readonly products: ProductDropdownItemProps[];
  readonly defaultOpen: boolean;

  readonly onSwitchAccountClick: () => void;
  readonly onProfileClick: () => void;
  readonly onLicensesClick: () => void;
  readonly onLogOutClick: () => void;

  readonly getStartedUrl: string;
  readonly onGetStartedClick?: () => void;
  readonly onMobileBackClick?: () => void;
  readonly onMobileCloseClick?: () => void;

  readonly avatarSrc?: string;
  readonly domRootId?: string;
} & WithAnalyticsEventsProps;

export type UserProfileDropdownState = {
  readonly isOpen: boolean;
};

export type onOpenChangeProps = {
  readonly event?: { [key: string]: unknown };
} & UserProfileDropdownState;

export class UserProfileDropdown extends Component<
  UserProfileDropdownProps,
  UserProfileDropdownState
> {
  public static defaultProps = {
    defaultOpen: false
  };

  public static messages = messages;

  public constructor(props: UserProfileDropdownProps) {
    super(props);

    this.state = {
      isOpen: props.defaultOpen
    };
  }

  public render() {
    const {
      userName,
      userEmail,
      products,
      avatarSrc,
      getStartedUrl,
      onGetStartedClick,
      onSwitchAccountClick,
      onProfileClick,
      onLicensesClick,
      onLogOutClick,
      onMobileBackClick,
      onMobileCloseClick,
      domRootId,
      createAnalyticsEvent,
      ...rest
    } = this.props;
    const { isOpen } = this.state;
    const trigger = (
      <Trigger
        userName={userName}
        isBorderVisible={isOpen}
        avatarSrc={avatarSrc}
      />
    );

    const onOpenChange = ({ isOpen: open }: onOpenChangeProps) => {
      if (open === true && createAnalyticsEvent) {
        const analyticsData = Object.assign(trackingData.dropdownToggle, {
          magnoliaComponentId: domRootId
        });

        const analyticsEvent = createAnalyticsEvent(analyticsData);
        analyticsEvent.fire();
      }
    };

    return (
      <DropdownMenu
        shouldFlip={false}
        trigger={trigger}
        onOpenChange={onOpenChange}
        {...rest}
      >
        <UserProfileView
          avatarSrc={avatarSrc}
          userName={userName}
          userEmail={userEmail}
          products={products}
          domRootId={domRootId}
          getStartedUrl={getStartedUrl}
          onGetStartedClick={onGetStartedClick}
          onSwitchAccountClick={onSwitchAccountClick}
          onProfileClick={onProfileClick}
          onLicensesClick={onLicensesClick}
          onLogOutClick={onLogOutClick}
          onMobileBackClick={onMobileBackClick}
          onMobileCloseClick={onMobileCloseClick}
        />
      </DropdownMenu>
    );
  }
}

export default withAnalyticsEvents()(UserProfileDropdown);
